import './footer.css';



const Footer = () => {
  return (
    <>
      <footer id="footer" className="text-center 1h-2 fs-11 font-medium pb-3">
        <div className="text-white py-5">
          <div className="container">
            <div className="row text-md-start text-lg-start d-flex justify-content-start">
              <div className="col-md-3"></div>
              <div className="col-md-3 col=sm-6 p-3">
                <h5 className="text-uppercase ms-5 mb-md-4">Help Center</h5>
                <ul className="ms-3" style={{ listStyleType: "none" }}>
                  <li>
                    <a href="">Term & Conditions</a>
                  </li>
                  <li>
                    <a href="">Privacy</a>
                  </li>
                  <li>
                    <a href="">Disclaimer</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3 col=sm-6 p-3">
                <h5 className="text-uppercase ms-5 mb-md-4">Company</h5>
                <ul className="ms-3" style={{ listStyleType: "none" }}>
                  <li>
                    <a href="mailto:wjcwelfare110@gmail.com">wjcwelfare110@gmail.com</a>
                  </li>
                  <li>
                      <u>
                        <span>(123) 456-7890</span>
                      </u>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <section className=" copy text-uppercase small bg-white ">
        <div className="container text-muted pt-3 pb-3 ">
          <div className="row">
            <div className="col-md-6 col-sm-6 ">
              © Copyright 2025.{" "}
              <span className="text-success">Wjcw Crowdfunding</span>. | All
              rights reserved.
            </div>
          </div>
        </div>
      </section>
    </>
  );
};


export default Footer;